import { UPDATE_STORE_VALUE } from 'js/store/reducer';

export default (key, value) => (dispatch) => {
  dispatch(({ type: UPDATE_STORE_VALUE, key, value }))
}
